///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2025, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2025 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { Viewer } from "../Viewer";

const DELAY_TIME_MULTIPLEXER = 2.0;
const START_UPDATE_TIME = 1000;

export enum UpdateType {
  kDelay,
  kNormal,
  kForce,
}

export class UpdateController {
  private lastUpdate: number;
  private viewer: Viewer;
  public delayUpdateTime: number;

  constructor() {
    this.lastUpdate = 0;
    this.delayUpdateTime = START_UPDATE_TIME;
  }

  initialize(viewer: Viewer) {
    this.viewer = viewer;
    this.lastUpdate = performance.now();
  }

  update(type: UpdateType) {
    const isNeedUpdate = type !== UpdateType.kDelay || performance.now() - this.lastUpdate >= this.delayUpdateTime;
    const isForce = type === UpdateType.kForce;

    if (isNeedUpdate) {
      this.viewer.update(isForce);
      this.lastUpdate = performance.now();
      this.delayUpdateTime *= DELAY_TIME_MULTIPLEXER;
    }
  }
}
